import * as yup from 'yup';
import { getEnterValidTextMessage, getMaxCharactersTextMessage, getMinCharactersTextMessage, getRequiredTextMessage } from '..';
export const enrollResidentPersonalInitialValues = {
  firstName: '',
  lastName: '',
  phone: '',
  primaryEmail: ''
};
export const enrollResidentPersonalScema = yup.object({
  firstName: yup.string().trim().min(2, getMinCharactersTextMessage('First name', 2)).max(50, getMaxCharactersTextMessage('First name', 50)).required(getRequiredTextMessage('First name')),
  lastName: yup.string().trim().min(2, getMinCharactersTextMessage('Last name', 2)).max(50, getMaxCharactersTextMessage('Last name', 50)).required(getRequiredTextMessage('Last name')),
  phone: yup.string().matches(/^(\+1 (?:\(\d{3}\)|\d{3}) \d{3}-\d{4})|(\+1(?:\(\d{3}\)|\d{3})\d{3}-\d{4})|(\+380 (?:\(\d{2}\)|\d{2}) \d{3} \d{2} \d{2})|(\+380(?:\(\d{2}\)|\d{2})\d{3}\d{2}\d{2})|(\d{3}-\d{3}-\d{4})$/, 'Invalid phone number.').notRequired(),
  primaryEmail: yup.string().trim().email(getEnterValidTextMessage('email address')).notRequired()
});